import {
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appDefaultImg][default]',
  standalone: true,
})
export class DefaultImageDirective {
  @Input()
  default;

  constructor(
    public renderer: Renderer2,
    private readonly hostElement: ElementRef<HTMLElement>
  ) {}

  @HostBinding('src')
  @Input()
  src: string;

  @HostListener('error')
  onError(): void {
    this.src = this.default;
    if (this.hostElement?.nativeElement) {
      const ele = this.hostElement.nativeElement;
      this.renderer.addClass(ele, 'error-img'); // add class to check on hover directive
      this.renderer.setAttribute(ele, 'alt', 'Default Image');
    }
  }
}
